const SizeIcon = ({ viewBox = "0 0 18 18", className = "hayley-h-[18px] hayley-w-[18px] hayley-text-white" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path d="M12.375 13.125V10.875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.125 13.125V10.875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.875 13.125V10.875" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6 7.875C7.44975 7.875 8.625 7.20343 8.625 6.375C8.625 5.54657 7.44975 4.875 6 4.875C4.55025 4.875 3.375 5.54657 3.375 6.375C3.375 7.20343 4.55025 7.875 6 7.875Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.375 11.625C3.375 12.4538 4.55025 13.125 6 13.125H14.625V7.875H6C4.55025 7.875 3.375 7.20375 3.375 6.375V11.625Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SizeIcon;
